import set from 'lodash/set';

export const validateIdentificationCodes = (codes = [], errors, identificationCodeTypes, t) => {
  codes.forEach((code, i) => {
    if (!code.identificationCodeTypeTag)
      set(errors, `identificationCodes[${i}].identificationCodeTypeTag`, t('pleaseSelectAType'));
    if (!code.value) set(errors, `identificationCodes[${i}].value`, t('pleaseEnterAValue'));

    const type = identificationCodeTypes.find(
      ict => String(ict.value) === code.identificationCodeTypeTag
    );

    if (code.value && type && type.validationPattern) {
      const pattern = new RegExp(type.validationPattern.pattern);
      if (!pattern.test(code.value)) {
        set(errors, `identificationCodes[${i}].value`, type.validationPattern.errorMessage);
      }
    }
  });
};
